import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tx-section-navigate-fields',
  templateUrl: './section-navigate-fields.component.html',
  styleUrls: ['./section-navigate-fields.component.scss'],
})
export class SectionNavigateFieldsComponent {
  @Input() disabled: boolean = false;
  @Input() unansweredCount: number = 0;
  @Output() previousClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() showUnansweredOnlyChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  onShowUnansweredOnlyChanged(event: any) {
    if (event != undefined) {
      this.showUnansweredOnlyChanged.emit(event);
    }
  }
}
